import _ from 'lodash'

export default
{
    methods:
    {
        /**
         * inArray wrapper
         */
        inArray(collection, key)
        {
            return (_.indexOf(collection, key) !== -1) ;
        },

        empty(obj)
        {
            return _.isEmpty(obj)
        },

        map(obj, arg)
        {
            return _.map(obj, arg)
        }
    }
}



// WEBPACK FOOTER //
// ./src/js/helpers/lodash.js